import { Routes, Route } from "react-router-dom";
import ProtectedRoute from "../utils/protectedRoutes";
import Dashboard from "../pages/protected/dashboard/dashboard";
import Customer from "../pages/protected/customer/customer";
import Invoice from "../pages/protected/invoice/invoice";
import CustomerDetail from "../pages/protected/customer/customerDetail/customerDetail";
import Settings from "../pages/protected/settings/settings";
// import Subscription from "../pages/protected/subscription";
import Accounting from "../pages/protected/accounting/accounting";
import Sidebar from "../components/sidebar/sidebar";
import Appointments from "../pages/protected/appointments/appointments";
import Todos from "../pages/protected/todos/todos";
import InvoiceDetail from "../pages/protected/invoice/invoiceDetail/invoiceDetail";
import AppointmentDetail from "../pages/protected/appointments/appointmentDetail";
import EventPage from "../pages/protected/events/eventPage";
import NotFound from "../pages/notFound/notFound";
import CreateCustomer from "../pages/protected/customer/components/createCustomer";
import { InvoiceProvider } from "../utils/invoiceProvider";
import { CustomerProvider } from "../utils/customerProvider";

const UserRoutes = () => {
  return (
      <div style={{ display: "flex", flex: 1 }}>
        <Sidebar />
        <div style={{ flex: 1 }}>
          <CustomerProvider>
            <InvoiceProvider>
              <Routes>
                <Route path="/" element={<ProtectedRoute element={<Dashboard />} />} /> 
                <Route path="/customer" element={<ProtectedRoute element={<Customer />} />} />
                <Route path="/customer/new" element={<ProtectedRoute element={<CreateCustomer />} />} />
                <Route path="/customer/:id" element={<ProtectedRoute element={<CustomerDetail />} />} />
                <Route path="/invoice" element={<ProtectedRoute element={<Invoice />} />} />
                <Route path="/invoice/:id" element={<ProtectedRoute element={<InvoiceDetail />} />} />
                <Route path="/settings" element={<ProtectedRoute element={<Settings />} />} />
                {/* <Route path="/subscription" element={<ProtectedRoute element={<Subscription />} />} /> */}
                <Route path="/accounting" element={<ProtectedRoute element={<Accounting />} />} />
                <Route path="/appointments" element={<ProtectedRoute element={<Appointments />} />} />
                <Route path="/appointments/:id" element={<ProtectedRoute element={<AppointmentDetail />} />} />
                <Route path="/todos" element={<ProtectedRoute element={<Todos />} />} />
                <Route path="/events" element={<ProtectedRoute element={<EventPage />} />} />
                {/* <Route path="/events/:id" element={<ProtectedRoute element={<AppointmentDetail />} />} /> */}

                <Route path="*" element={<NotFound />} />
              </Routes>
            </InvoiceProvider>
          </CustomerProvider>
        </div>
      </div>
  );
};

export default UserRoutes;